<template>
    <div v-if="time || showEmpty" class="caption tabular-nums">
        {{ time | format_time_duration }}
    </div>
</template>

<script>
export default {
    name: "RichDataTableDuration",
    props: {
        time: {
            type: Number,
            default: null
        },
        showEmpty: {
            type: Boolean,
            default: true
        }
    }
};
</script>
